import { VimeoFrame, AllSponsorModal } from "src/utils/fw"


export default {
    background: "https://assets.swoogo.com/uploads/full/1455641-6182a6bac8678.jpg",
    links: [
        {
            href: "/lobby",
            label: "To Lobby",
            width: "16.4%",
            height: "8.1%",
            left: "0.5%",
            top: "0.9%",
        },
        {
            label: "Duck Creek Logo",
            modal: <AllSponsorModal URL="https://quadient.tkeventsregistration.com/inspire2021/sponsor/180946/duckcreek" />,
            width: "7.3%",
            height: "7.7%",
            left: "25.7%",
            top: "17.4%",
        },
        {
            label: "Duck Creek Video",
            width: "6%",
            height: "6.5%",
            left: "19.5%",
            top: "20.7%",
            modal: <VimeoFrame wrapperStyle={{ backgroundColor: "#7536f0" }}
                vidId="641939205?h=6b217513ce&autoplay=1"
            ></VimeoFrame>
        },
        {
            label: "Chat With Duck Creek",
            width: "9.3%",
            height: "10.9%",
            left: "10.1%",
            top: "27.8%",
            CometChatID: "duck"
        },
        {
            label: "Duck Creek Download",
            width: "3.8%",
            height: "7%",
            left: "24.3%",
            top: "32.2%",
            onClick: () => { document.getElementById("quadient2021-duck-download").click() },
        },
        {
            label: "Duck Creek Contact",
            onClick: () => { document.getElementById("quadient2021-duck").click() },
            width: "3.8%",
            height: "7.9%",
            left: "28.2%",
            top: "32%",
        },
        {
            label: "Capgemini Logo",
            modal: <AllSponsorModal URL="https://quadient.tkeventsregistration.com/inspire2021/sponsor/179425/capgemini" />,
            width: "7.1%",
            height: "7.7%",
            left: "39.1%",
            top: "17.4%",
        },
        {
            label: "Capgemini Video",
            width: "5.8%",
            height: "6.7%",
            left: "47%",
            top: "20.4%",
            modal: <VimeoFrame wrapperStyle={{ backgroundColor: "#7536f0" }}
                vidId="644823337?h=099215f44a&autoplay=1"
            ></VimeoFrame>
        },
        {
            label: "Capgemini Download",
            href: "https://assets.swoogo.com/uploads/1471562-619275789ce19.pdf",
            isExternal: true,
            target: "_blank",
            width: "3.7%",
            height: "7.2%",
            left: "38.8%",
            top: "32.3%",
        },
        {
            label: "Capgemini Contact",
            onClick: () => { document.getElementById("quadient2021-cap").click() },
            width: "3.7%",
            height: "7.4%",
            left: "42.6%",
            top: "32%",
        },
        {
            label: "Chat With Capgemini",
            width: "8.6%",
            height: "11.8%",
            left: "52.2%",
            top: "27.8%",
            CometChatUserID: "13198698",
        },
        {
            label: "Blue Rush Logo",
            modal: <AllSponsorModal URL="https://quadient.tkeventsregistration.com/inspire2021/sponsor/180953/bluerush" />,
            width: "7%",
            height: "6.9%",
            left: "67%",
            top: "17.4%",
        },
        {
            label: "Blue Rush Video",
            width: "5.7%",
            height: "6.2%",
            left: "74.6%",
            top: "20.6%",
            modal: <VimeoFrame wrapperStyle={{ backgroundColor: "#7536f0" }}
                vidId="646045792?h=69047768a4&autoplay=1"
            ></VimeoFrame>
        },
        {
            label: "Blue Rush Contact",
            onClick: () => { document.getElementById("quadient2021-blue").click() },
            width: "3.8%",
            height: "8.6%",
            left: "67.8%",
            top: "31.6%",
        },
        {
            label: "Blue Rush Download",
            href: "https://assets.swoogo.com/uploads/1471566-619275be84b3c.pdf",
            isExternal: true,
            target: "_blank",
            width: "3.9%",
            height: "7.9%",
            left: "71.8%",
            top: "32%",
        },
        {
            label: "Chat With Blue Rush",
            width: "9%",
            height: "10.5%",
            left: "80%",
            top: "28.8%",
            CometChatID: "blue",
        },
        {
            label: "Canon Logo",
            modal: <AllSponsorModal URL="https://quadient.tkeventsregistration.com/inspire2021/sponsor/179424/canon" />,
            width: "8.6%",
            height: "9.3%",
            left: "20.3%",
            top: "53.6%",
        },
        {
            label: "Canon Video",
            width: "7.2%",
            height: "7.9%",
            left: "12.3%",
            top: "55.9%",
            modal: <VimeoFrame wrapperStyle={{ backgroundColor: "#7536f0" }}
                vidId="641937382?h=1456c7fffc&autoplay=1"
            ></VimeoFrame>
        },
        {
            label: "Chat With Canon",
            width: "11.5%",
            height: "15.3%",
            left: "1%",
            top: "65.9%",
            CometChatID: "canon",
        },
        {
            label: "Canon Download",
            href: "https://assets.swoogo.com/uploads/1471574-6192766423b02.pdf",
            isExternal: true,
            target: "_blank",
            width: "4.7%",
            height: "8.4%",
            left: "17.7%",
            top: "73.5%",
        },
        {
            label: "Canon Contact",
            onClick: () => { document.getElementById("quadient2021-canon").click() },
            width: "4.6%",
            height: "8.3%",
            left: "22.5%",
            top: "73.6%",
        },
        {
            label: "Cognizant Logo",
            modal: <AllSponsorModal URL="https://quadient.tkeventsregistration.com/inspire2021/sponsor/179426/cognizant" />,
            width: "9%",
            height: "10.7%",
            left: "54.3%",
            top: "52.5%",
        },
        {
            label: "Cognizant Video",
            width: "7%",
            height: "7.7%",
            left: "46.5%",
            top: "55.9%",
            modal:
                <VimeoFrame wrapperStyle={{ backgroundColor: "#7536f0" }}
                    vidId="641938070?h=02964971a3&autoplay=1">
                </VimeoFrame>
        },
        {
            label: "Chat With Cognizant",
            width: "9.5%",
            height: "13.9%",
            left: "37%",
            top: "67%",
            CometChatID: "cognizant",
        },
        {
            label: "Cognizant Contact",
            onClick: () => { document.getElementById("quadient2021-cognizant").click() },
            width: "4.9%",
            height: "9.1%",
            left: "54.4%",
            top: "73.1%",
        },
        {
            label: "Cognizant Download",
            href: "https://assets.swoogo.com/uploads/1471578-6192769f97b22.pdf",
            isExternal: true,
            target: "_blank",
            width: "4.4%",
            height: "8.6%",
            left: "59.6%",
            top: "73.3%",
        },
        {
            label: "The Quad Logo",
            width: "3.6%",
            height: "7.6%",
            left: "73.5%",
            top: "53.8%",
        },
        {
            label: "The Quad Video",
            width: "7.4%",
            height: "7.6%",
            left: "80.5%",
            top: "55.7%",
            modal: <VimeoFrame wrapperStyle={{ backgroundColor: "#7536f0" }}
                vidId="644768247?h=b79e91ea66&autoplay=1"
            ></VimeoFrame>
        },
        {
            label: "The Quad Contact",
            onClick: () => { document.getElementById("quadient2021-quad").click() },
            width: "4.8%",
            height: "8.8%",
            left: "72.6%",
            top: "72.9%",
        },
        {
            label: "The Quad Download",
            href: "https://assets.swoogo.com/uploads/1471732-61928268638ac.pdf",
            isExternal: true,
            target: "_blank",
            width: "4.5%",
            height: "8.1%",
            left: "77.6%",
            top: "73.8%",
        },
        {
            label: "Chat With The Quad",
            width: "10.8%",
            height: "14.9%",
            left: "87.9%",
            top: "66.3%",
            CometChatID: "quad"
        },
    ],
    name: "exhibition-hall",
}